import get from "lodash/get";
import React, { useState } from "react";
import set from "@rill/set";
import { useTranslation } from "react-i18next";
import Select from "../../../parts/inputs/select";
import { useRillContext } from "../../../rill/RillReact/share/base";

function View(props) {
  const { locals } = useRillContext();
  const { t } = useTranslation("dashboard");

  const { activeUser } = locals;
  const [selected, setSelected] = useState("Billing");
  const [message, setMessage] = useState("");
  return (
    <main role="reports-wrapper" className="support contact">
      <article role="report-content">
        <header>
          <h3>{t("supportContact.contactUs")}</h3>
          <p className="guide-text">{t("supportContact.guideText")}</p>
        </header>
        <form id="form-contact" method="POST">
          <input type="hidden" name="name" value={get(activeUser, "name")} />
          <input type="hidden" name="email" value={get(activeUser, "email")} />
          <input type="hidden" name="isFromWeb" value={true} />
          <Select
            name="type"
            title={t("supportContact.typeOfInquiry")}
            options={[
              { value: "Billing", text: t("supportContact.billing") },
              { value: "Technical", text: t("supportContact.technical") },
              { value: "Business", text: t("supportContact.business") },
              { value: "Marketing", text: t("supportContact.marketing") },
              { value: "Feedback", text: t("supportContact.feedback") },
              { value: "Other", text: t("common:other") },
            ]}
            value={selected}
            onChange={(val) => setSelected(val)}
          />
          <textarea
            className="textarea-input"
            placeholder={t("supportContact.messagePlaceholder")}
            required
            name="message"
            onInput={(e) => setMessage(e.target.value)}
          />

          <button data-button-type="primary" disabled={!message} type="submit">
            {t("supportContact.send")}
          </button>
        </form>
      </article>
    </main>
  );
}

const Contact = (app) => {
  app
    .post("/contact", async ({ req, res, api, flash, assert }) => {
      const { body } = req;
      assert(body.type, 400, "You must pick a type of inquiry");
      assert(body.message, 400, "You must type a message");
      flash("success", "Successfully sent");
      await api("contact", { method: "POST", body });
      return res.backDontScroll();
    })
    .get(
      "/contact",
      set("heading", ["Contact Us"]),
      ({ res }) => (res.body = <View />)
    );
};

export default Contact;
